import {
  Swiper, Scrollbar, Keyboard, FreeMode, Mousewheel, Navigation,
} from 'swiper';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const swiperContainerClass = '.js-side-scrolling-cards__swiper';

function initcarousel(container) {
  // eslint-disable-next-line no-new
  new Swiper(container, {
    slidesPerView: 'auto',
    spaceBetween: 10,
    grabCursor: true,
    mousewheel: true,
    breakpoints: {
      768: {
        spaceBetween: 16,
      },
    },
    freeMode: {
      enabled: true,
      sticky: false,
    },
    modules: [Scrollbar, Keyboard, FreeMode, Mousewheel, Navigation],
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.side-scrolling-cards__button--next',
      prevEl: '.side-scrolling-cards__button--prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
      dragClass: 'side-scrolling-cards__scrollbar-drag',
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/side-scrolling-cards', ($block) => {
      initcarousel($block.find(swiperContainerClass)[0]);
    });
  } else {
    initcarousel(swiperContainerClass);
  }
});

function preventDefault(e) {
  e.preventDefault();
}

let supportsPassive = false;
try {
  window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
    // eslint-disable-next-line getter-return
    get() { supportsPassive = true; },
  }));
} catch (e) { /* empty */ }

const wheelOpt = supportsPassive ? { passive: false } : false;
const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

function disableScroll() {
  window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
  window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
}

function enableScroll() {
  window.removeEventListener('DOMMouseScroll', preventDefault, false);
  window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
}

document.querySelectorAll(swiperContainerClass).forEach((item) => {
  item.addEventListener(
    'mouseenter',
    () => {
      if (window.innerWidth > breakpoints.md) {
        disableScroll();
      }
    },
    false,
  );

  item.addEventListener(
    'mouseleave',
    () => {
      if (window.innerWidth > breakpoints.md) {
        enableScroll();
      }
    },
    false,
  );
});
